import axios from "axios";
import { BASEURL } from "baseUrl";
import { toast } from "react-toastify";

export const UPDATE_SETTING = 'UPDATE_SETTING';
export const GET_LEAD_STATUS = "GET_LEAD_STATUS";
export const ADD_LEAD_STATUS = "ADD_LEAD_STATUS";
export const UPDATE_LEAD_STATUS = "UPDATE_LEAD_STATUS";
export const DELETE_LEAD_STATUS = "DELETE_LEAD_STATUS";
export const GET_SETTING = "GET_SETTING";
export const CREATE_WHATSAPP_MESSAGE = "CREATE_WHATSAPP_MESSAGE";
export const GET_ALL_WHATSAPP_MESSAGE = "GET_ALL_WHATSAPP_MESSAGE";
export const DELETE_WHATSAPP_MESSAGE = "DELETE_WHATSAPP_MESSAGE";
export const UPDATE_WHATSAPP_MESSAGE = "UPDATE_WHATSAPP_MESSAGE";
export const GET_WHATSAPP_BYID = "GET_WHATSAPP_BYID";
export const GET_ALL_MESSAGE = "GET_ALL_MESSAGE";
export const ADD_LEAD_FROM = "ADD_LEAD_FROM";
export const GET_LEAD_FROM = "GET_LEAD_FROM";
export const UPDATE_LEAD_FROM = "UPDATE_LEAD_FROM";
export const DELETE_LEAD_FROM = "DELETE_LEAD_FROM";
export const MANAGE_AUTO_ASSIGN = "MANAGE_AUTO_ASSIGN";
export const GET_ALL_LEAD_FROM = "GET_ALL_LEAD_FROM";
export const CREATE_EMAIL_TEMPLATE = "CREATE_EMAIL_TEMPLATE";
export const GET_ALL_EMAIL_TEMPLATES = "GET_ALL_EMAIL_TEMPLATES";
export const GET_EMAIL_TEMPLATE_BY_ID = "GET_EMAIL_TEMPLATE_BY_ID";
export const UPDATE_EMAIL_TEMPLATE = "UPDATE_EMAIL_TEMPLATE";
export const DELETE_EMAIL_TEMPLATE = "DELETE_EMAIL_TEMPLATE";
export const SET_ALL_EMAIL_TEMPLATES = "SET_ALL_EMAIL_TEMPLATES";
export const GET_CONFIGURATION_STATUS = "GET_CONFIGURATION_STATUS";
export const ADD_CONFIGURATION_STATUS = "ADD_CONFIGURATION_STATUS";
export const UPDATE_CONFIGURATION_STATUS = "UPDATE_CONFIGURATION_STATUS";
export const DELETE_CONFIGURATION_STATUS = "DELETE_CONFIGURATION_STATUS";


const updateSettingAction = (payload) => ({ type: UPDATE_SETTING, payload: payload });
const getLeadStatusAction = (payload) => ({ type: GET_LEAD_STATUS, payload });
const addLeadStatusAction = (payload) => ({ type: ADD_LEAD_STATUS, payload });
const updateLeadStatusAction = (payload) => ({ type: UPDATE_LEAD_STATUS, payload });
const deleteLeadStatusAction = (id) => ({ type: DELETE_LEAD_STATUS, payload: id });
const getSettingAction = (payload) => ({ type: GET_SETTING, payload });
const createWhatsAppMessageAction = (payload) => ({ type: CREATE_WHATSAPP_MESSAGE, payload });
const getAllWhatsAppMessageAction = (payload) => ({ type: GET_ALL_WHATSAPP_MESSAGE, payload });
const deleteWhatsAppMessageAction = (payload) => ({ type: DELETE_WHATSAPP_MESSAGE, payload });
const updateWhatsAppMessageAction = (payload) => ({ type: UPDATE_WHATSAPP_MESSAGE, payload });
const getWhatsAppByIdAction = (payload) => ({ type: GET_WHATSAPP_BYID, payload });
const getAllMessageAction = (payload) => ({ type: GET_ALL_MESSAGE, payload });
const addLeadFromAction = (payload) => ({ type: ADD_LEAD_FROM, payload });
const getLeadFromAction = (payload) => ({ type: GET_LEAD_FROM, payload });
const updateLeadFromAction = (payload) => ({ type: UPDATE_LEAD_FROM, payload });
const deleteLeadFromAction = (payload) => ({ type: DELETE_LEAD_FROM, payload });
const manageAutoAssignAction = (payload) => ({ type: MANAGE_AUTO_ASSIGN, payload });
const getAllLeadFromAction = (payload) => ({ type: GET_ALL_LEAD_FROM, payload });
const createEmailTemplateAction = (payload) => ({ type: CREATE_EMAIL_TEMPLATE, payload });
const getAllEmailTemplatesAction = (payload) => ({ type: GET_ALL_EMAIL_TEMPLATES, payload });
const getEmailTemplateByIdAction = (payload) => ({ type: GET_EMAIL_TEMPLATE_BY_ID, payload });
const updateEmailTemplateAction = (payload) => ({ type: UPDATE_EMAIL_TEMPLATE, payload });
const deleteEmailTemplateAction = (payload) => ({ type: DELETE_EMAIL_TEMPLATE, payload });
const setAllEmailTemplates = (payload) => ({ type: SET_ALL_EMAIL_TEMPLATES, payload });
const getConfigurationStatusAction = (payload) => ({ type: GET_CONFIGURATION_STATUS, payload });
const addConfigurationStatusAction = (payload) => ({ type: ADD_CONFIGURATION_STATUS, payload });
const updateConfigurationStatusAction = (payload) => ({ type: UPDATE_CONFIGURATION_STATUS, payload });
const deleteConfigurationStatusAction = (payload) => ({ type: DELETE_CONFIGURATION_STATUS, payload });


// Get All Lead Statuses
export const getSetting = () => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem("token");
            const res = await axios.get(`${BASEURL}/Setting/getSetting`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(getSettingAction(res.data));
        } catch (error) {
            console.error("Error fetching lead statuses:", error);
            // toast.error("Failed to load lead statuses!");
        }
    };
};

export const updateSetting = (payload) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.put(`${BASEURL}/Setting/updateSetting`, payload, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(((res) => {
                dispatch(updateSettingAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(updateSettingAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

// Get All Lead Statuses
export const getLeadStatusesWithPagination = (page, limit) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem("token");
            const res = await axios.get(`${BASEURL}/Setting/all-with-pagination?page=${page}&limit=${limit}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(getLeadStatusAction(res.data));
        } catch (error) {
            console.error("Error fetching lead statuses:", error);
            // toast.error("Failed to load lead statuses!");
        }
    };
};

export const getConfigurationStatusesWithPagination = (page, limit) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem("token");
            const res = await axios.get(`${BASEURL}/Setting/voiceAIStatus/get`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(getConfigurationStatusAction(res.data));
        } catch (error) {
            console.error("Error fetching configuration statuses:", error);
        }
    };
};

// Add New Lead Status
export const addLeadStatus = (payload) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem("token");
            const res = await axios.post(`${BASEURL}/Setting/add-lead-status`, payload, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(addLeadStatusAction(res.data));
            toast.success("Lead Status added successfully!");
        } catch (error) {
            console.error("Error adding lead status:", error);
            toast.error("Failed to add lead status!");
        }
    };
};

export const addConfigurationStatus = (payload) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem("token");
            const res = await axios.post(`${BASEURL}/Setting/voiceAIStatus/create`, payload, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(addConfigurationStatusAction(res.data));
            toast.success("Configuration Status added successfully!");
        } catch (error) {
            console.error("Error adding configuration status:", error);
            toast.error("Failed to add configuration status!");
        }
    };
};

// Update Lead Status
export const updateLeadStatus = (id, payload) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem("token");
            const res = await axios.put(`${BASEURL}/Setting/update/${id}`, payload, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(updateLeadStatusAction(res.data));
            toast.success("Lead Status updated successfully!");
        } catch (error) {
            console.error("Error updating lead status:", error);
            toast.error("Failed to update lead status!");
        }
    };
};

export const updateConfigurationStatus = (id, payload) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem("token");
            const res = await axios.put(`${BASEURL}/Setting/voiceAIStatus/update/${id}`, payload, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(updateConfigurationStatusAction(res.data));
            toast.success("Configuration Status updated successfully!");
        } catch (error) {
            console.error("Error updating configuration status:", error);
            toast.error("Failed to update configuration status!");
        }
    };
};

// Delete Lead Status
export const deleteLeadStatus = (id) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem("token");
            await axios.delete(`${BASEURL}/Setting/delete/${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(deleteLeadStatusAction(id));
            toast.success("Lead Status deleted successfully!");
        } catch (error) {
            console.error("Error deleting lead status:", error);
            toast.error("Failed to delete lead status!");
        }
    };
};

export const deleteConfigurationStatus = (id) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem("token");
            await axios.delete(`${BASEURL}/Setting/voiceAIStatus/delete/${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(deleteConfigurationStatusAction(id));
            toast.success("Configuration Status deleted successfully!");
        } catch (error) {
            console.error("Error deleting configuration status:", error);
            toast.error("Failed to delete configuration status!");
        }
    };
};

// Add New WhatsApp Message
export const addWhatsAppMessage = (payload) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem("token");
            const res = await axios.post(`${BASEURL}/Setting/whatsapp-message`, payload, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(createWhatsAppMessageAction(res.data));

        } catch (error) {
            console.error("Error adding WhatsApp Message:", error);
            toast.error("Failed to add WhatsApp Message!");
        }
    };
};

// Get ALL WhatsApp Message
export const getWhatsAppMessage = (page, limit) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem("token");
            const res = await axios.get(`${BASEURL}/Setting/whatsapp-message?page=${page}&limit=${limit}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(getAllWhatsAppMessageAction(res.data));
            return res
        } catch (error) {
            console.error("Error adding WhatsApp Message:", error);
            // toast.error("Failed to add WhatsApp Message!");
        }
    };
};

// Get ALL WhatsApp Message
export const getMessage = () => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem("token");
            const res = await axios.get(`${BASEURL}/Setting/whatsapp-message-all`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(getAllMessageAction(res.data));
            return res
        } catch (error) {
            console.error("Error adding WhatsApp Message:", error);
            toast.error("Failed to add WhatsApp Message!");
        }
    };
};

// Get WhatsApp Message BY ID
export const getWhatsAppMessageById = (payload) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem("token");
            const res = await axios.post(`${BASEURL}/Setting/whatsapp-message/${payload.id}`, payload, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(getWhatsAppByIdAction(res.data));
            toast.success("WhatsApp Message get successfully!");
        } catch (error) {
            console.error("Error adding WhatsApp Message:", error);
            toast.error("Failed to add WhatsApp Message!");
        }
    };
};

// Update WhatsApp Message
export const updateWhatsAppMessage = (id, payload) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem("token");
            const res = await axios.put(`${BASEURL}/Setting/whatsapp-message/${id}`, payload, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(updateWhatsAppMessageAction(res.data));
            toast.success("WhatsApp Message updated successfully!");
        } catch (error) {
            console.error("Error updating WhatsApp Message:", error);
            toast.error("Failed to update WhatsApp Message!");
        }
    };
};

// Delete WhatsApp Message
export const deleteWhatsAppMessage = (id) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem("token");
            await axios.delete(`${BASEURL}/Setting/whatsapp-message/${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(deleteWhatsAppMessageAction(id));
            toast.success("WhatsApp Message deleted successfully!");
        } catch (error) {
            console.error("Error deleting WhatsApp Message:", error);
            toast.error("Failed to delete WhatsApp Message!");
        }
    };
};

// Add New Email Template
export const addEmailTemplate = (payload) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem("token");
            const res = await axios.post(`${BASEURL}/Setting/email-template`, payload, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(createEmailTemplateAction(res.data));
            toast.success("Email Template added successfully!");
        } catch (error) {
            console.error("Error adding Email Template:", error);
            toast.error("Failed to add Email Template!");
        }
    };
};

// Get Paginated Email Templates
export const getEmailTemplates = (page, limit) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem("token");
            const res = await axios.get(`${BASEURL}/Setting/email-template?page=${page}&limit=${limit}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(getAllEmailTemplatesAction(res.data));
        } catch (error) {
            console.error("Error getting Email Templates:", error);
            toast.error("Failed to fetch Email Templates!");
        }
    };
};

// Get All Email Templates (no pagination)
export const fetchAllEmailTemplates = () => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem("token");
            const res = await axios.get(`${BASEURL}/Setting/email-template-all`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(setAllEmailTemplates(res.data)); 
            return res;
        } catch (error) {
            console.error("Error fetching all Email Templates:", error);
            toast.error("Failed to fetch Email Templates!");
        }
    };
};


// Get Email Template By ID
export const getEmailTemplateById = (id) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem("token");
            const res = await axios.get(`${BASEURL}/Setting/email-template/${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(getEmailTemplateByIdAction(res.data));
            toast.success("Email Template loaded successfully!");
        } catch (error) {
            console.error("Error getting Email Template by ID:", error);
            toast.error("Failed to fetch Email Template!");
        }
    };
};

// Update Email Template
export const updateEmailTemplate = (id, payload) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem("token");
            const res = await axios.put(`${BASEURL}/Setting/email-template/${id}`, payload, {
                headers: { Authorization: `Bearer ${token}` },
            });

            // Only dispatch the updated object
            dispatch(updateEmailTemplateAction(res.data)); 
            toast.success("Email Template updated successfully!");
        } catch (error) {
            console.error("Error updating Email Template:", error);
            toast.error("Failed to update Email Template!");
        }
    };
};


// Delete Email Template
export const deleteEmailTemplate = (id) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem("token");
            await axios.delete(`${BASEURL}/Setting/email-template/${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(deleteEmailTemplateAction(id));
            toast.success("Email Template deleted successfully!");
        } catch (error) {
            console.error("Error deleting Email Template:", error);
            toast.error("Failed to delete Email Template!");
        }
    };
};
// Add Lead From
export const addLeadFrom = (payload) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem("token");
            const res = await axios.post(`${BASEURL}/Setting/lead-from`, payload, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(addLeadFromAction(res.data));
            toast.success("Lead From added successfully!");
        } catch (error) {
            console.error("Error adding lead from:", error);
            toast.error("Failed to add lead from!");
        }
    };
};

// Get Lead From with Pagination
export const getLeadFrom = (page, limit) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem("token");
            const res = await axios.get(`${BASEURL}/Setting/lead-from?page=${page}&limit=${limit}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(getLeadFromAction(res.data));
        } catch (error) {
            console.error("Error fetching lead from:", error);
            toast.error("Failed to load lead from!");
        }
    };
};

// Update Lead From
export const updateLeadFrom = (id, payload) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem("token");
            const res = await axios.put(`${BASEURL}/Setting/lead-from-edit/${id}`, payload, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(updateLeadFromAction(res.data));
            toast.success("Lead From updated successfully!");
        } catch (error) {
            console.error("Error updating lead from:", error);
            toast.error("Failed to update lead from!");
        }
    };
};

// Delete Lead From
export const deleteLeadFrom = (id) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem("token");
            await axios.delete(`${BASEURL}/Setting/lead-from/${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(deleteLeadFromAction(id));
            toast.success("Lead From deleted successfully!");
        } catch (error) {
            console.error("Error deleting lead from:", error);
            toast.error("Failed to delete lead from!");
        }
    };
};

// Manage Auto Assign
export const manageAutoAssign = (payload) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem("token");
            const res = await axios.put(`${BASEURL}/Setting/lead-from/auto-assign`, payload, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(manageAutoAssignAction(res.data));
            toast.success("Auto assign updated successfully!");
        } catch (error) {
            console.error("Error updating auto assign:", error);
            toast.error("Failed to update auto assign!");
        }
    };
};

// Get All Lead From 
export const getAllLeadFrom = () => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem("token");
            const res = await axios.get(`${BASEURL}/Setting/get-lead-froms`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(getAllLeadFromAction(res.data));
        } catch (error) {
            console.error("Error fetching lead from:", error);
            toast.error("Failed to load lead from!");
        }
    };
};